/* tslint:disable */
/* eslint-disable */
/**
 * 
 * This api document example is the Mainnet document, and the Testnet base URL is api.oasisscan.com/v2/testnet
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AccountRewardStatsItem,
    AccountRewardStatsItemFromJSON,
    AccountRewardStatsItemFromJSONTyped,
    AccountRewardStatsItemToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccountRewardStatsInfo
 */
export interface AccountRewardStatsInfo {
    /**
     * 
     * @type {string}
     * @memberof AccountRewardStatsInfo
     */
    validatorName: string;
    /**
     * 
     * @type {Array<AccountRewardStatsItem>}
     * @memberof AccountRewardStatsInfo
     */
    rewardList: Array<AccountRewardStatsItem>;
    /**
     * 
     * @type {string}
     * @memberof AccountRewardStatsInfo
     */
    total: string;
}

export function AccountRewardStatsInfoFromJSON(json: any): AccountRewardStatsInfo {
    return AccountRewardStatsInfoFromJSONTyped(json, false);
}

export function AccountRewardStatsInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccountRewardStatsInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'validatorName': json['validatorName'],
        'rewardList': ((json['rewardList'] as Array<any>).map(AccountRewardStatsItemFromJSON)),
        'total': json['total'],
    };
}

export function AccountRewardStatsInfoToJSON(value?: AccountRewardStatsInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'validatorName': value.validatorName,
        'rewardList': ((value.rewardList as Array<any>).map(AccountRewardStatsItemToJSON)),
        'total': value.total,
    };
}


